import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { TbPlus } from "react-icons/tb";

import Animation from "@areas/shared/components/chooseLayout/Animation";
import animationStyles from "@areas/shared/components/chooseLayout/styles/animations.module.css";

import ButtonDanger from "@areas/shared/components/buttons/ButtonDanger";
import CustomModal from "@areas/shared/components/personal/modals/CustomModal";

import { fetchWrapper } from "@helpers/fetchwrapper";

import Table from "./blocks/Table";
import {
  initialValues,
  validationSchema,
  confirm,
  ModalBodyAdd,
} from "./blocks/ModalAdd";

function Frame() {
  const [showModal, setShowModal] = useState(false);
  const [headerModal, setHeaderModal] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [allData, setAllData] = useState([]);
  const [load, setLoad] = useState(false);
  const [relation, setRelation] = useState(null);
  const [search, setSearch] = useState("");

  const loadData = useCallback(() => {
    setLoad(true);
    fetchWrapper
      .get(
        `/v1/api/app/GetCareerGuidanceRelations?text=${encodeURIComponent(
          search
        )}`
      )
      .then((res) => {
        const list = Array.isArray(res) ? res : res?.data || [];
        setAllData(list);
        setLoad(false);
      })
      .catch(() => {
        setAllData([]);
        setLoad(false);
      });
  }, [search]);

  const handleSearch = useCallback((text) => {
    setSearch(text.trim());
    setPage(1);
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const total = allData.length;

  const data = useMemo(() => {
    const offset = page * perPage - perPage;
    return allData.slice(offset, offset + perPage);
  }, [allData, page, perPage]);

  const handlePageChange = (nextPage) => {
    setPage(nextPage);
  };

  const handlePerRowsChange = async (newPerPage, nextPage) => {
    setPerPage(newPerPage);
    setPage(nextPage);
  };

  const toggle = useCallback(
    (item) => {
      if (showModal) {
        setShowModal(false);
        setRelation(null);
      } else {
        if (!item) {
          setHeaderModal("Добавление карьерной связи");
        } else {
          setHeaderModal("Редактирование карьерной связи");
        }
        setRelation(item || null);
        setShowModal(true);
      }
    },
    [showModal]
  );

  return (
    <div>
      <Animation
        animationIn={animationStyles.fadeIn}
        animationOut={animationStyles.fadeOut}
      >
        <Card>
          <CardHeader>
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Карьерные связи</h5>
              <ButtonDanger onClick={() => toggle()}>
                <TbPlus />
                Добавить
              </ButtonDanger>
            </div>
          </CardHeader>
          <CardBody>
            <Table
              data={data}
              load={load}
              total={total}
              handlePageChange={handlePageChange}
              handlePerRowsChange={handlePerRowsChange}
              toggleModal={toggle}
              onSearch={handleSearch}
            />
          </CardBody>
        </Card>
        <CustomModal
          isOpen={showModal}
          toggle={toggle}
          header={headerModal}
          body={(validation) => <ModalBodyAdd validation={validation} />}
          validateYupSchema={validationSchema}
          inititalValues={() => initialValues(relation)}
          cancel="Закрыть"
          confirm="Сохранить"
          confirmFunction={(values) => {
            confirm(values, loadData);
          }}
        />
      </Animation>
    </div>
  );
}

export default Frame;
